module.exports = __webpack_public_path__ + "img/img_3.0c264fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobileb/img_3.png
// module id = XWML
// module chunks = 1